import React, { useState } from 'react';
import './SignInForm.css'
import { useAuth } from '../Hooks/useAuth';
import { toast } from '@mobiscroll/react';

const SignInForm = ({ onExitPopup }) => {
  const { handleLoginWithEmail } = useAuth();
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handlePassword = (event) => {
    setPassword(event.target.value);
  };

  const handleEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async () => {
    if (!email || !password) {
      toast({
        message: 'Please enter both email and password',
        color: 'danger'
      });
      return;
    }

    setIsLoading(true);
    try {
      await handleLoginWithEmail(email, password);
      onExitPopup(); // Close the form on successful login
    } catch (error) {
      let message = error.message.replace('Firebase:', '');
      toast({
        message: `${message}`,
        color: 'danger'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div id="login-container" className='login-container'>
      <div id='login-form' className='login-form'>
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <p>Email</p>
          <input
            placeholder='Enter Email'
            type="email"
            value={email}
            onChange={handleEmail}
            onKeyDown={onKeyDown}
            disabled={isLoading}
          />
          <p>Password</p>
          <input
            placeholder='Enter Password'
            type="password"
            value={password}
            onChange={handlePassword}
            onKeyDown={onKeyDown}
            disabled={isLoading}
          />
          <button
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Log in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignInForm;